export const MAX_WIDTH = 258;
export const MAX_HEIGHT = 206;
